export default __webpack_public_path__ + "static/media/errors2.15bf5978.jpg";